import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-azure-modernizing',
  templateUrl: './azure-modernizing.component.html',
  styleUrls: ['./azure-modernizing.component.css']
})
export class AzureModernizingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
